import { useState } from 'react';
import { api, setSession } from '../api/client.ts';
import { chargerPermissions } from '../config/permissions.ts';
import { NOM_APPLICATION } from '../config/affichage.ts';

/** Changement de mot de passe OBLIGATOIRE à la première connexion (comptes créés ou réinitialisés par l'administrateur). */
export default function ChangerMdp({ onFait, onSortie }: { onFait: () => void; onSortie: () => void }) {
  const [ancien, setAncien] = useState('');
  const [nouveau, setNouveau] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: React.FormEvent) {
    e.preventDefault();
    setErreur(null);
    if (nouveau.length < 8) return setErreur('Le nouveau mot de passe doit contenir au moins 8 caractères.');
    if (nouveau !== confirmation) return setErreur('Les deux mots de passe ne sont pas identiques.');
    setEnCours(true);
    try {
      const r = await api.post<{ token: string; role: string; csbId: string | null; nomCompte?: string }>('/auth/changer-mdp', { ancien, nouveau });
      setSession(r.token, r.role, r.csbId, r.nomCompte ?? '');
      localStorage.removeItem('prerma_mdp_a_changer');
      await chargerPermissions();
      onFait();
    } catch (err: any) {
      setErreur(err.message ?? 'Changement impossible');
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="app-content">
      <h1>{NOM_APPLICATION}</h1>
      <h2>Choisissez votre mot de passe</h2>
      <p>Pour la sécurité de vos données, vous devez remplacer le mot de passe initial avant de continuer.</p>
      <form onSubmit={soumettre}>
        <label htmlFor="ancien">Mot de passe actuel (initial)</label>
        <input id="ancien" type="password" value={ancien} onChange={(e) => setAncien(e.target.value)} required autoFocus autoComplete="current-password" />
        <label htmlFor="nouveau">Nouveau mot de passe (8 caractères minimum)</label>
        <input id="nouveau" type="password" value={nouveau} onChange={(e) => setNouveau(e.target.value)} required minLength={8} autoComplete="new-password" />
        <label htmlFor="confirmation">Confirmer le nouveau mot de passe</label>
        <input id="confirmation" type="password" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} required minLength={8} autoComplete="new-password" />
        {erreur && <p className="messages-erreur">{erreur}</p>}
        <div style={{ marginTop: 20 }}>
          <button type="submit" disabled={enCours}>{enCours ? 'Enregistrement…' : 'Enregistrer et continuer'}</button>{' '}
          <button type="button" className="secondaire" onClick={onSortie}>Se déconnecter</button>
        </div>
      </form>
    </div>
  );
}
